import useAxios from 'axios-hooks';

export enum CVUP_ROLE {
  CVUP_APPROVER = 'CVUP_APPROVER',
  CVUP_CREATOR = 'CVUP_CREATOR',
}

export interface IUserProfile {
  I_COMPANY: number;
  N_NAME: string;
  E_COMPANY: string;
  N_SURNAME: string;
  I_COMPANY_ID: number;
  N_COMPANY_ENG: string;
  N_ROLES: string[];
  N_LOGIN: string;
  N_COMPANY_THAI: string;
}

export interface IRefreshToken {
  code: string;
  message: string;
  token: string;
  refreshToken: string;
  profile: null;
}

export const useGetUserProfile = (jwt: string) => {
  return useAxios<IUserProfile>({
    url: `/auth/profile`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
      accept: '*/*',
    },
  });
};

export const useRefreshToken = (jwt: string) => {
  return useAxios<IRefreshToken>({
    url: `/auth/refreshToken`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${jwt}`,
      accept: '*/*',
    },
  });
};
